<template>
  <v-container>
    <app-navigation></app-navigation>
    <v-main class="pt-12">
      <div class="pt-md-5">
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 class="mx-1 mb-1 pa-0">
            <main-sub-page-toolbar icon="mdi-cash-multiple"
              >{{ $route.params.subPath }} ({{
                $t("dashboardCardModulePhotoOrderPricesButtonTitle")
              }})</main-sub-page-toolbar
            >
          </v-flex>
          <v-flex xs12 class="mx-1 mb-1 pa-0 animated fadeIn">
            <v-card
              class="#505050--text mb-12"
              :class="
                getTheme() == 'dark'
                  ? 'outlined elevation-0'
                  : 'flat elevation-0'
              "
              :style="
                getTheme() == 'dark'
                  ? 'border: 1px solid darkgray; background-color: whitesmoke'
                  : 'border: none; background-color: white'
              "
            >
              <!-- cenik za slike po meri -->
              <v-card-title
                v-if="
                  $store.state.storeGift.gift.length > 0 &&
                  $store.state.storeGift.gift[0].allowCustomSize &&
                  $store.state.storeImageSize.imageSize.length > 0
                "
                >{{
                  $t("dashboardCardModulePhotoOrderUserSubTitle")
                }}</v-card-title
              >
              <v-card-text
                v-if="
                  $store.state.storeGift.gift.length > 0 &&
                  $store.state.storeGift.gift[0].allowCustomSize &&
                  $store.state.storeImageSize.imageSize.length > 0
                "
              >
                <v-simple-table
                  dense
                  style="border: 1px solid lightgray; max-width: 600px"
                >
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">
                          {{ $t("settingsImageCustomSizeTitle") }}
                        </th>
                        <th class="text-center">
                          {{ $t("settingsImageSizeGridHeaderPriceTitle") }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in $store.state.storeImageSize.imageSize
                          .slice()
                          .sort((a, b) => a.price - b.price)"
                        :key="item.name"
                      >
                        <td>{{ item.name }}</td>
                        <td class="text-center">
                          {{ price(getPrice(item.price)) }}
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card-text>

              <!--<v-card-title
                v-if="
                  $store.state.storeGift.gift.length > 0 &&
                  $store.state.storeGift.gift[0].allowCustomSize &&
                  $store.state.storePaperType.paperType.length > 0
                "
                class="pt-0 mt-0"
                >{{ $t("dashboardCardSuperAdminPaperType") }}</v-card-title
              >
              <v-card-text
                v-if="
                  $store.state.storeGift.gift.length > 0 &&
                  $store.state.storeGift.gift[0].allowCustomSize &&
                  $store.state.storePaperType.paperType.length > 0
                "
              >
                <v-simple-table
                  dense
                  style="border: 1px solid lightgray; max-width: 600px"
                >
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">
                          {{ $t("settingsPaperTypeGridHeaderPaperTypeTitle") }}
                        </th>
                        <th class="text-center">
                          {{ $t("settingsPaperTypeGridHeaderPriceTitle") }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in $store.state.storePaperType.paperType
                          .slice()
                          .sort((a, b) => a.price - b.price)"
                        :key="item.paperType"
                      >
                        <td>{{ item.paperType }}</td>
                        <td class="text-center">{{ percent(item.price) }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card-text>-->

              <!-- cenik za ostale izdelke -->
              <v-card-text v-else>
                <v-simple-table
                  dense
                  style="border: 1px solid lightgray; max-width: 600px"
                >
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-center">
                          {{ $t("settingsPhotoGiftCategoryTitle") }}
                        </th>
                        <th class="text-left">
                          {{ $t("userCartModPhotoGiftPackageTitle") }}
                        </th>
                        <th class="text-center">
                          {{ $t("settingsImageSizeGridHeaderPriceTitle") }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in $store.state.storeGift.gift"
                        :key="item.id"
                      >
                        <td class="text-center">{{ item.giftCategory }}</td>
                        <td>{{ item.name }}</td>
                        <td
                          v-if="item.typeArray.length == 0"
                          class="text-center"
                        >
                          {{ price(item.price) }}
                        </td>
                        <td v-else class="text-center">
                          {{ getPrices(item.typeArray) }}
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card-text>
              <v-card-text
                v-if="
                  Number(
                    $store.state.storeClient.client.modules.modulePhotoGift
                      .taxPct
                  ) > 0
                "
                class="caption pt-0"
                >{{ $t("userOrdersIncludesTax") }}
                {{
                  $store.state.storeClient.client.environmentSettings.taxTitle
                }}.</v-card-text
              >
            </v-card>
          </v-flex>
          <simple-navigation-button
            left
            :title="$t('lmBtnBack')"
            icon="mdi-arrow-left"
            @clicked="$router.push({ name: 'home' })"
          ></simple-navigation-button>
        </v-layout>
      </div>
    </v-main>
  </v-container>
</template>

<script>
import AppNavigation from "@/views/AppNavigation";
import MainSubPageToolbar from "@/components/MainSubPageToolbar";
import SimpleNavigationButton from "@/components/SimpleNavigationButton";

export default {
  name: "userGiftPrices",
  components: {
    AppNavigation,
    MainSubPageToolbar,
    SimpleNavigationButton,
  },
  data() {
    return {
      netBackImage: require("@/assets/netBack.png"),
      imageCostPct: 0,
    };
  },
  methods: {
    getPrice(price) {
      let temp = Number(price) + Number(price * this.imageCostPct) / 100;
      console.log(price);
      console.log(this.imageCostPct);
      console.log((Number(price) * Number(this.imageCostPct)) / 100);
      console.log(temp);
      console.log("---");
      return temp;
    },
    getPrices(typeArray) {
      // izračunamo price range
      let temp = [];
      typeArray.forEach((y) => {
        if (temp.indexOf(y.price) === -1) temp.push(y.price);
      });
      temp.sort();
      if (temp.length == 1) {
        return this.price(temp[0]);
      } else
        return this.price(temp[0]) + "-" + this.price(temp[temp.length - 1]);
    },
    async initPrices() {
      await this.$store.dispatch("getGift", {
        client: this.$store.state.storeClient.client.basicSettings.name,
        superCategory: this.$route.params.subPath,
        mode: "price",
      });
      let vm = this;
      setTimeout(() => {
        if (
          vm.$store.state.storeGift.gift.length > 0 &&
          vm.$store.state.storeGift.gift[0].allowCustomSize
        )
          vm.imageCostPct = vm.$store.state.storeGift.gift[0].price;
      }, 1000);
    },
  },
  created() {
    this.initPrices();
  },
};
</script>
